
  import { defineComponent } from 'vue'
  import Spinner from '../spinner/spinner.vue'

  export default defineComponent({
    components: { Spinner },
  })
